import React from 'react';
import shadowSvg from '../../images/shadow.svg';
import flameSvg from '../../images/flame.svg';
import bodySvg from '../../images/body.svg';
import leftEyebrowSvg from '../../images/left-eyebrow.svg';
import rightEyebrowSvg from '../../images/right-eyebrow.svg';
import leftEyeSvg from '../../images/left-eye.svg';
import rightEyeSvg from '../../images/right-eye.svg';
import smileLineSvg from '../../images/smile-line.svg';
import mouthSvg from '../../images/Mouth.svg';
import leftHandSvg from '../../images/left-hand.svg';
import rightHandSvg from '../../images/right-hand.svg';
import sparklesSvg from '../../images/sparkles.svg';

// Animated Upselly mascot assembled from individually rigged SVG parts.
// Part offsets are the rig — tuned so the pieces line up; adjust with care.
// The face is itself composed from individual features (offsets derived from
// their path coordinates within the original 218x226 face viewBox) so the
// eyes, brows, and mouth can animate independently.
export default function UpsellyMascot({ size = 300, className = '' }) {
	return (
		<div className={`upselly ${className}`} style={{ width: size, height: size }} aria-hidden="true">
			<img className="u-part u-shadow" src={shadowSvg} alt="" />
			<div className="u-boost">
				<div className="u-float">
					<img className="u-part u-flame" src={flameSvg} alt="" />
					<img className="u-part u-body" src={bodySvg} alt="" />
					<div className="u-part u-face">
						<img className="u-fpart u-brow-l" src={leftEyebrowSvg} alt="" />
						<img className="u-fpart u-brow-r" src={rightEyebrowSvg} alt="" />
						<img className="u-fpart u-eye-l" src={leftEyeSvg} alt="" />
						<img className="u-fpart u-eye-r" src={rightEyeSvg} alt="" />
						<img className="u-fpart u-smile-line" src={smileLineSvg} alt="" />
						<img className="u-fpart u-mouth" src={mouthSvg} alt="" />
					</div>
					<img className="u-part u-left-hand" src={leftHandSvg} alt="" />
					<img className="u-part u-right-hand" src={rightHandSvg} alt="" />
					<img className="u-part u-sparkles" src={sparklesSvg} alt="" />
				</div>
			</div>
		</div>
	);
}
